import { dateTimeFormat } from "@/Helpers/times-ago";
import { Button } from "@/shadcnComponents/ui/button";

import axios from "axios";
import { useEffect, useState } from "react";
import { BiRightArrowAlt } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { NoItemToDisplayMessage, TableRow } from "./Components/Components";
import mixpanel from "mixpanel-browser";
import { MessageLoader } from "@/Components/Loader/MessageLoader";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

const ReviewTableRows = [
  "Campaign Name",
  "campaignID",
  "Created at",
  "Campaign Expense",
  "Influencers Shortlisted",
  "Influencers Confirmed",
  "Status",
  "Action",
];
const LiveTableRows = [
  "Campaign Name",
  "campaignID",
  "Campaign Start Date",
  "Budget",
  "Expected Impression",
  "Accepted Influencers",
  "Status",
  "Action",
];
const DraftTableRows = [
  "Campaign Name",
  "campaignID",
  "Created At",
  "Budget",
  "Action",
];

export const PromoteAdDashboard = () => {
  //hooks -------------------------------

  const navigate = useNavigate();

  //states ------------------------------
  const [, setAllCampaigns] = useState([]);
  const [draftCampaigns, setDraftCampaigns] = useState([]);
  const [reviewCampaigns, setReviewCampaigns] = useState([]);
  const [liveCampaigns, setLiveCampaigns] = useState([]);
  const [currentSection, setCurrentSection] = useState("Draft");
  const [currentTable, setCurrentTable] = useState([]);
  const [loading, setLoading] = useState(false);

  const query = new URLSearchParams(window.location.search);
  const section = query?.get("section");

  //effects ----------------------------
  useEffect(() => {
    mixpanel.track("Brand Dashboard Page Visited");
  }, []);
  useEffect(() => {
    const fetchAllCampaigns = async () => {
      if (
        localStorage.getItem("jwtToken") &&
        localStorage.getItem("UserType").toLocaleLowerCase() === "brand"
      ) {
        try {
          setLoading(true);
          const res = await axios.get(`${host}/collabs/brand/getAllCollab`, {
            headers: {
              jwtToken: localStorage.getItem("jwtToken"),
            },
          });

          if (res?.status === 200 && res?.data?.success) {
            setAllCampaigns(res?.data?.AllCollabs);
            setDraftCampaigns(res?.data?.draftCollabs);
            setLiveCampaigns(res?.data?.LiveCollabs);
            setReviewCampaigns(res?.data?.reviewCollabs);
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      }
    };

    fetchAllCampaigns();
  }, []);
  useEffect(() => {
    if (currentSection === "Live") {
      setCurrentTable(LiveTableRows);
    } else if (currentSection === "Review") {
      setCurrentTable(ReviewTableRows);
    } else if (currentSection === "Draft") {
      setCurrentTable(DraftTableRows);
    }
  }, [currentSection]);
  useEffect(() => {
    if (section === "Review" || section === "Payment") {
      setCurrentSection("Review");
    } else if (section === "Live") {
      setCurrentSection("Live");
    } else {
      setCurrentSection("Draft");
    }
  }, [section]);

  //functions -----------------------------
  const handleOpenCampaign = (collabId, status, section) => {
    if (status === 3) {
      navigate(`Draft/${collabId}`);
    } else {
      navigate(`Campaign/${collabId}/?section=${section}`);
    }
  };

  return (
    <>
      {loading ? (
        <MessageLoader className="h-screen" />
      ) : (
        <div
          className={`${
            loading ? " hidden" : ""
          } w-full min-h-full font-inter flex flex-col py-5 px-10 overflow-auto bg-white`}
        >
          <div className="flex justify-between">
            <div>
              <h1 className="font-bold text-2xl">Manage Campaigns</h1>
            </div>
          </div>
          <div className="w-full gap-[15px] flex mt-[20px] ">
            <div className="flex items-center gap-4">
              <Button
                onClick={() => {
                  mixpanel.track("Brand Dashboard: Live Section - clicked");
                  setCurrentSection("Live");
                }}
                variant="outline"
                className={`border-2 ${
                  currentSection === "Live" ? "bg-[#4b4b4b] text-[#FFF] " : ""
                } px-4 py-2 rounded-md text-sm font-[400] hover:border-red-600 hover:text-red-600`}
              >
                Live
              </Button>
              <Button
                onClick={() => {
                  mixpanel.track("Brand Dashboard: Review Section - clicked");
                  setCurrentSection("Review");
                }}
                variant="outline"
                className={`border-2 ${
                  currentSection === "Review" ? "bg-[#4b4b4b] text-[#FFF] " : ""
                } px-4 py-2 rounded-md text-sm font-[400] hover:border-red-600 hover:text-red-600`}
              >
                Review Pending
              </Button>
              <Button
                onClick={() => {
                  mixpanel.track("Brand Dashboard: Draft Section - clicked");
                  setCurrentSection("Draft");
                }}
                variant="outline"
                className={`border-2 ${
                  currentSection === "Draft" ? "bg-[#4b4b4b] text-[#FFF] " : ""
                } px-4 py-2 rounded-md text-sm font-[400] hover:border-red-600 hover:text-red-600`}
              >
                In Drafts
              </Button>
            </div>
          </div>
          <div className="w-full flex flex-col gap-[5px] mt-[40px] ">
            <div
              className={`grid p-2 ${
                currentSection === "Draft" ? "grid-cols-5" : "grid-cols-8"
              }`}
            >
              {currentTable?.map((item, index) => (
                <span
                  className=" flex flex-wrap justify-start p-1  text-[color:var(--Natural-500,#9E9E9E)] text-sm not-italic font-semibold leading-5 "
                  key={`row-item-${index}`}
                >
                  {item}
                </span>
              ))}
            </div>
            {currentSection === "Draft" &&
              (draftCampaigns?.length > 0 ? (
                draftCampaigns?.map((campaign, index) => (
                  <div
                    key={campaign?._id}
                    className="grid grid-cols-5 p-2 border bg-[color:var(--Shade-White,#FFF)] rounded-[5px] border-solid border-[#EEE]"
                  >
                    {[
                      campaign?.campaignInfo?.campaignName,
                      campaign?.campaignId ?? "-",
                      dateTimeFormat(campaign?.createdAt),
                      campaign?.Budget?.maxBillAmount,
                      <Button
                        className="text-white text-xs not-italic font-bold leading-[normal]"
                        onClick={() => {
                          mixpanel.track(
                            "Brand Dashboard Draft section: Edit Button - clicked"
                          );
                          handleOpenCampaign(
                            campaign?._id,
                            campaign?.status,
                            "Draft"
                          );
                        }}
                        variant="destructive"
                      >
                        Edit <BiRightArrowAlt />
                      </Button>,
                    ].map((columnItem, columnIndex) => (
                      <TableRow
                        key={`row-item-${campaign?._id}_${
                          (index + 1) * columnIndex
                        }`}
                        children={columnItem}
                      />
                    ))}
                  </div>
                ))
              ) : (
                <NoItemToDisplayMessage />
              ))}
            {currentSection === "Review" &&
              (reviewCampaigns?.length > 0 ? (
                reviewCampaigns?.map((campaign, index) => (
                  <div
                    key={campaign?._id}
                    className="grid grid-cols-8 p-2 border bg-[color:var(--Shade-White,#FFF)] rounded-[5px] border-solid border-[#EEE]"
                  >
                    {[
                      campaign?.campaignInfo?.campaignName,
                      campaign?.campaignId ?? "-",
                      dateTimeFormat(campaign?.createdAt),
                      `₹${parseFloat(
                        campaign?.ROI?.safeExpense?.max?.toFixed(2)
                      )}`,
                      campaign?.acceptedResponses + campaign?.pendingResponses,
                      campaign?.acceptedResponses,
                      campaign?.brandApprovalAccepted ===
                      campaign?.influencerSelection?.selectedInfluencers
                        ?.length +
                        campaign?.influencerSelection
                          ?.manuallySelectedInfluencers?.length ? (
                        <span className="text-[#1B6B05] text-[14px] not-italic font-normal leading-[normal] inline-flex justify-center items-center gap-2.5 bg-[#B7FF7C33] px-1.5 py-1 rounded-[100px]">
                          Ready To Live
                        </span>
                      ) : (
                        <span className="text-[#55F] text-[14px] not-italic font-normal leading-[normal] inline-flex justify-center items-center gap-2.5 bg-[rgba(163,163,255,0.20)] px-1.5 py-1 rounded-[100px]">
                          Review pending
                        </span>
                      ),
                      <Button
                        className="text-white text-xs not-italic font-bold leading-[normal]"
                        onClick={() => {
                          mixpanel.track(
                            "Brand Dashboard Review section: View Details Button - clicked"
                          );
                          handleOpenCampaign(
                            campaign?._id,
                            campaign?.status,
                            campaign?.brandApprovalAccepted ===
                              campaign?.influencerSelection?.selectedInfluencers
                                ?.length +
                                campaign?.influencerSelection
                                  ?.manuallySelectedInfluencers?.length
                              ? "Payment"
                              : "Review"
                          );
                        }}
                        variant="destructive"
                      >
                        {campaign?.brandApprovalAccepted ===
                        campaign?.influencerSelection?.selectedInfluencers
                          ?.length +
                          campaign?.influencerSelection
                            ?.manuallySelectedInfluencers?.length
                          ? "Make it Live"
                          : "View Details"}{" "}
                        <BiRightArrowAlt />
                      </Button>,
                    ].map((columnItem, columnIndex) => (
                      <TableRow
                        key={`row-item-${campaign?._id}_${
                          (index + 1) * columnIndex
                        }`}
                        children={columnItem}
                      />
                    ))}
                  </div>
                ))
              ) : (
                <NoItemToDisplayMessage />
              ))}
            {currentSection === "Live" &&
              (liveCampaigns?.length > 0 ? (
                liveCampaigns?.map((campaign, index) => (
                  <div
                    key={campaign?._id}
                    className="grid grid-cols-8 p-2 border bg-[color:var(--Shade-White,#FFF)] rounded-[5px] border-solid border-[#EEE]"
                  >
                    {[
                      campaign?.campaignInfo?.campaignName,
                      campaign?.campaignId ?? "-",
                      dateTimeFormat(campaign?.campaignInfo?.campaignStartDate),
                      `₹${parseFloat(
                        campaign?.ROI?.safeExpense?.max.toFixed(2)
                      )}`,
                      campaign?.campaignInfo?.collabType === "performance"
                        ? parseInt(
                            campaign?.ROI?.safeSelectedImpression?.min || 0,
                            10
                          )
                        : "-",
                      campaign?.acceptedResponses,
                      new Date(Date.now()) <
                      new Date(campaign?.campaignInfo?.campaignStartDate) ? (
                        <span className="text-[#DC2627] text-[14px] not-italic font-normal leading-[normal] inline-flex justify-center items-center gap-2.5 bg-[#FFCACA] px-1.5 py-1 rounded-[100px]">
                          Upcoming
                        </span>
                      ) : new Date(Date.now()) >
                        new Date(campaign?.campaignInfo?.campaignEndDate) ? (
                        <span className="text-[#121212] text-[14px] not-italic font-normal leading-[normal] inline-flex justify-center items-center gap-2.5 bg-[#39373833] px-1.5 py-1 rounded-[100px]">
                          Completed
                        </span>
                      ) : (
                        <span className="text-[#115E59] text-[14px] not-italic font-normal leading-[normal] inline-flex justify-center items-center gap-2.5 bg-[#36D7CC33] px-1.5 py-1 rounded-[100px]">
                          Live
                        </span>
                      ),
                      <Button
                        className="text-white text-xs not-italic font-bold leading-[normal]"
                        onClick={() => {
                          mixpanel.track(
                            "Brand Dashboard Live section: Check Performance Button - clicked"
                          );
                          handleOpenCampaign(
                            campaign?._id,
                            campaign?.status,
                            "Live"
                          );
                        }}
                        variant="destructive"
                      >
                        Check Performance <BiRightArrowAlt />
                      </Button>,
                    ].map((columnItem, columnIndex) => (
                      <TableRow
                        key={`row-item-${campaign?._id}_${
                          (index + 1) * columnIndex
                        }`}
                        children={columnItem}
                      />
                    ))}
                  </div>
                ))
              ) : (
                <NoItemToDisplayMessage />
              ))}
          </div>
        </div>
      )}
    </>
  );
};
